import { useMemo, useCallback } from 'react';
import { Home, ChevronRight } from 'lucide-react';
import {
    BreadcrumbContainer,
    BreadcrumbButton,
    BreadcrumbSeparator,
    BreadcrumbSegment,
} from './styled';
import type { FolderBreadcrumbsProps } from './types';

const FolderBreadcrumbs = ({
    currentPath,
    onNavigate,
    rootLabel = 'Root',
}: FolderBreadcrumbsProps) => {
    const segments = useMemo(() => {
        if (!currentPath) return [];
        return currentPath.split('/').filter(Boolean);
    }, [currentPath]);

    const handleSegmentClick = useCallback(
        (index: number) => {
            if (index === -1) {
                onNavigate('');
            } else {
                const path = '/' + segments.slice(0, index + 1).join('/');
                onNavigate(path);
            }
        },
        [segments, onNavigate]
    );

    return (
        <BreadcrumbContainer>
            <BreadcrumbButton onClick={() => handleSegmentClick(-1)}>
                <Home className="h-4 w-4 mr-1" />
                <span>{rootLabel}</span>
            </BreadcrumbButton>

            {segments.map((segment, index) => {
                const isLast = index === segments.length - 1;
                return (
                    <BreadcrumbSegment key={`${segment}-${index}`}>
                        <BreadcrumbSeparator>
                            <ChevronRight className="h-4 w-4" />
                        </BreadcrumbSeparator>
                        <BreadcrumbButton
                            onClick={() => handleSegmentClick(index)}
                            $isActive={isLast}
                        >
                            {segment}
                        </BreadcrumbButton>
                    </BreadcrumbSegment>
                );
            })}
        </BreadcrumbContainer>
    );
};

export default FolderBreadcrumbs;
